<irembogov-offcanvas
  title="Add New Certificate"
  description="Add new certificate"
  [paneOpen]="isPaneOPen"
  (OnPaneToggle)="updateToggleState($event)">
  <ng-template>
    <irembogov-irembo-section-message
      *ngIf="showFormErrorMessage"
      [type]="formAlertContent.type"
      [title]="formAlertContent.title"
      [message]="formAlertContent.message"></irembogov-irembo-section-message>
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <formly-form
        [form]="form"
        [fields]="fields"
        [options]="formlyFormOptions"
        [model]="model"></formly-form>

      <button
        type="submit"
        class="btn btn-primary w-100"
        [disabled]="!form.valid || isUploadingCertificate">
        {{ isUploadingCertificate ? 'Submitting...' : 'Create Template' }}
      </button>
    </form>
  </ng-template>
</irembogov-offcanvas>
<div class="certificate-template-list-widget">
  <div class="card bg-transparent border-0">
    <div
      class="card-header bg-transparent border-0 d-flex justify-content-between align-items-center">
      <h5 class="mb-0">Certificate Templates</h5>
      <div class="d-flex gap-2">
        <button class="btn btn-primary" (click)="openPaneForCertificate()">
          <i class="fas fa-upload me-2"></i>Upload Template
        </button>
        <button class="btn btn-outline-primary" (click)="navigateToDesignNew()">
          <i class="fas fa-plus me-2"></i>Design New
        </button>
        <button class="btn btn-outline-primary" (click)="onRefresh()">
          <i class="fas fa-arrows-rotate me-2"></i>Refresh
        </button>
      </div>
    </div>
    <div class="card-body bg-white border-0">
      <irembogov-custom-table-wrapper
        wapperTopPaddingClass="pt-0"
        wapperTopMarginClass="mt-1"
        [isSortVisible]="true"
        [isSeachVisible]="true"
        [sortFieldOptions]="sortFieldOptions"
        [loading]="isLoading"
        [paginationVisible]="true"
        [pageSizes]="[5, 10, 50, 100]"
        [totalItems]="collectionSize"
        [itemsPerPage]="pageSize"
        [currentPage]="((_filterObject | async)?.page || 0) + 1"
        (paginationChange)="
          updateTemplateList({
            page: $event.pageNumber - 1,
            size: $event?.pageSize
          })
        "
        (sortChange)="updateTemplateList({ sort: $event })">
        <table
          body
          aria-label="Irembo Certificate Templates Table"
          class="table">
          <thead>
            <tr>
              <th>Template Name</th>
              <th>Template Language</th>
              <th>Template Type</th>
              <th>Certificate Code</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let template of certificateTemplates">
              <td>
                {{ template.certificateTemplateName }}
                <button
                  class="btn btn-sm btn-light ms-2"
                  (click)="copyTemplateCode(template.certificateTemplateName)"
                  title="Copy Template Name">
                  <i class="far fa-copy"></i>
                </button>
              </td>
              <td>{{ template.templateLanguage }}</td>
              <td>{{ template.type }}</td>
              <td>
                <span class="badge bg-light text-dark">{{
                  template.code
                }}</span>
                <button
                  class="btn btn-sm btn-light ms-2"
                  (click)="copyTemplateCode(template.code)"
                  title="Copy Code">
                  <i class="far fa-copy"></i>
                </button>
              </td>
              <td>
                <div class="d-flex gap-1">
                  <button
                    *ngIf="canEdit(template)"
                    class="btn btn-sm btn-outline-primary"
                    (click)="navigateToEdit(template.code)"
                    title="Edit Template">
                    <i class="fas fa-edit me-1"></i>Edit
                  </button>
                  <button
                    class="btn btn-sm btn-outline-primary"
                    (click)="navigateToPreview(template.code)"
                    title="Preview Template">
                    <i class="fas fa-eye me-1"></i>Preview
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </irembogov-custom-table-wrapper>
    </div>
  </div>
</div>
